export default __webpack_public_path__ + "static/canberra-1-a3090624c7afb742ac6a1a596eb534e0.jpg";